import { FirstToFileFeatureFlags } from '@model/widget.model';
import { createAction, props } from '@ngrx/store';

/**
 * Action to set feature flags.
 */
export const setFeatureFlags = createAction('[Feature Flags] Set Feature Flags', props<{ featureFlags: FirstToFileFeatureFlags }>());

/**
 * Action to set the loaded state of feature flags.
 */
export const setLoaded = createAction('[Feature Flags] Set Loaded', props<{ isLoaded: boolean }>());
